export const ENTITY_LABELS = {
  pipeline: { singular: 'Pipeline', plural: 'Pipelines' },
  integration: { singular: 'Integration', plural: 'Integrations' },
};
